import React, { FunctionComponent } from 'react';
import { useSelectWithParams } from '../../../../utils/selector.utils';
import { companyContextsSelectors } from '../../../../app/resource/company-contexts/company-contexts.selectors';

interface ISectionReadOnlyProps {
  companyContextId: string;
}

export const SectionReadOnly: FunctionComponent<ISectionReadOnlyProps> = ({ companyContextId }) => {
  const companyContext = useSelectWithParams(companyContextsSelectors.selectResourceById, companyContextId);

  if (!companyContext || companyContext.title === '' || companyContext.content === '') {
    return null;
  }

  return (
    <div className="panel mb-3">
      <div className="panel-body">
        <div className="panel theme-gradient-2 py-1 px-2 flex aic">
          <h2 className="bold white">{companyContext.title}</h2>
        </div>
        {companyContext.summary !== '' && (
          <p
            className="flex align-center justify-start p-1 mt-2 mb-0 border-radius-1"
            style={{ border: '1px solid var(--theme-primary-color)' }}
          >
            {companyContext.summary}
          </p>
        )}
        <div
          className="ql-editor context-read-content"
          style={{ whiteSpace: 'nowrap' }}
          dangerouslySetInnerHTML={{ __html: companyContext.content ?? '' }}
        ></div>
      </div>
    </div>
  );
};
